import { css } from 'styled-system/css';
import { HeadCell } from './HeadCell';
import { RowGutter } from './RowGutter';
import { colAlign } from './sheetData';

export function HeaderRow({
  labels,
  wide,
  soft,
}: {
  labels: string[];
  wide?: boolean;
  soft?: boolean;
}) {
  return (
    <div
      data-wide={wide || undefined}
      className={css({
        display: 'grid',
        gridTemplateColumns:
          '36px minmax(0, 1.2fr) minmax(0, 1fr) minmax(0, 1fr)',
        borderBottom: '1px solid token(colors.border.hairline)',
        color: 'text.muted',
        '&[data-wide]': {
          gridTemplateColumns: '47px repeat(7, 64px)',
        },
      })}
    >
      <RowGutter n={1} soft={soft} />
      {labels.map((label, c) => (
        <HeadCell key={c} align={colAlign(c)}>
          {label}
        </HeadCell>
      ))}
    </div>
  );
}
